import React, { useContext } from 'react';
import styles from '../../css/components/common/partner.css';
import PropTypes from 'prop-types';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';
import { getAssetUrl } from '../../helpers/get-asset-url';

function PartnerBar({
	url,
	text = '',
	name = '',
}) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const backgroundPosterImage = onelpsParams.partner.image?.src && getAssetUrl() + require('../../img/' + GAMEID + '/partners/' + onelpsParams.partner.image.src);

	return (
		<div
			className={`${styles.partnerBar} ${styles[name]}`}
			style={{ backgroundImage: 'url(' + backgroundPosterImage + ')' }}
		>
			<a href={url}>{text}</a>
		</div>
	);
}

export default PartnerBar;

PartnerBar.propTypes = {
	url: PropTypes.string.isRequired,
	text: PropTypes.string,
	name: PropTypes.string
};